/**
 * Skip navigation link for keyboard users and screen readers.
 * Allows users to bypass repetitive navigation and jump directly to main content.
 *
 * WCAG 2.1 Level AA - Success Criterion 2.4.1 (Bypass Blocks):
 * A mechanism is available to bypass blocks of content that are repeated on multiple pages.
 *
 * The link is visually hidden until focused via keyboard (Tab key),
 * at which point it becomes visible at the top of the viewport.
 */
export function SkipNavigation({ mainContentId = 'main-content' }: { mainContentId?: string }) {
  return (
    <a
      href={`#${mainContentId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:rounded-lg focus:bg-brand-600 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
